export const commonViewTexts = {
  cancel: 'キャンセル',
  edit: '編集',
  delete: '削除',
  instantDelete: 'すぐに削除',
  register: '登録する',
  save: '保存する',
  download: 'ダウンロード',
  backToListPage: '一覧に戻る',
  koumuten: '工務店',
  company: '設計会社',
  model: '推論モデル',
  blueprint: '図面',
  label: 'ラベル',
  project: 'プロジェクト',
  user: 'ユーザー',
  csv: 'CSV',
  blueprintData: '図面データ',
  name: '名前',
  emailAddress: 'メールアドレス',
  password: 'パスワード',
  dateCreated: '作成日時',
  dateUpdated: '更新日時',
  author: '作成者',
  registerer: '登録者'
} as const;
